const OUTLINE = '#1d2a3a';
const PRIMARY = '#6c4cff';
const PRIMARY_LIGHT = '#b9a8ff';
const GLASS = '#ffffff';
// Same orange as the Support Us button (--color-accent).
const FLASK_LIQUID = '#ff7a59';

// Framed with a little space all round so nothing touches the edge.
const VIEW_BOX = '-5.5 -1.5 66 66';

// The dropper is drawn lying flat, then tilted up to the right around its tip.
const DROPPER_TIP = { x: 20, y: 22 };
const DROPPER_TILT_DEGREES = -30;

/**
 * A dropper letting a drop fall into a conical flask. Original drawing in the site's
 * purple and orange theme, used for the "Learn by playing" card.
 */
export default function DropperFlaskIcon({ size = 64, className }) {
  return (
    <svg className={className} width={size} height={size} viewBox={VIEW_BOX} role="img" aria-label="A dropper adding a drop to a flask">
      {/* dropper: tip, glass tube with marks, collar and squeeze bulb */}
      <g transform={`rotate(${DROPPER_TILT_DEGREES} ${DROPPER_TIP.x} ${DROPPER_TIP.y})`}>
        <path d="M20 21.2 H24 V22.8 H20 Z" fill={PRIMARY_LIGHT} stroke={OUTLINE} strokeWidth="1" strokeLinejoin="round" />
        <rect x="24" y="19.5" width="16" height="5" rx="1" fill={GLASS} stroke={OUTLINE} strokeWidth="1.4" />
        <rect x="24.8" y="21.3" width="7" height="2.4" fill={PRIMARY_LIGHT} />
        <path d="M28 19.5 V21.3 M32 19.5 V21.3 M36 19.5 V21.3" stroke={OUTLINE} strokeWidth="0.8" />
        <rect x="40" y="18.5" width="4" height="7" rx="1" fill={PRIMARY} stroke={OUTLINE} strokeWidth="1.4" />
        <circle cx="49" cy="22" r="5.5" fill={PRIMARY} stroke={OUTLINE} strokeWidth="1.4" />
        <circle cx="47.3" cy="20.3" r="1.4" fill={GLASS} opacity="0.7" />
      </g>

      {/* falling drop */}
      <path d="M19.2 25.5 q-2.1 3 0 4.1 q2.1 -1.1 0 -4.1 z" fill={PRIMARY_LIGHT} stroke={PRIMARY} strokeWidth="0.8" />

      {/* conical flask: long neck, wide body, orange liquid */}
      <path d="M11.3 49 H26.7 L32.4 58.6 Q33 60.4 31.2 60.4 H6.8 Q5 60.4 5.6 58.6 Z" fill={FLASK_LIQUID} />
      <path
        d="M15.5 31.5 V42 L5 58.8 Q4.2 61 6.6 61 H31.4 Q33.8 61 33 58.8 L22.5 42 V31.5"
        fill="none"
        stroke={OUTLINE}
        strokeWidth="1.8"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path d="M14.2 31.5 H23.8" stroke={OUTLINE} strokeWidth="2" strokeLinecap="round" />
      <path d="M17.6 34 V41.5 L13.5 48" stroke={GLASS} strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.9" />
      <path d="M10 56 L12.8 51.5" stroke={GLASS} strokeWidth="1.4" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
}
